export default "__VITE_ASSET__Bq45x5hn__"